<template>
    <div class="emoji-code-container">
        <single-emoji-code
                :class="activeEmojiIndex === i ? 'emoji-code-active' : ''"
                v-bind:code="singleCode"
                v-bind:key="i"
                v-bind:type="type"
                v-for="(singleCode, i) in codeParts"
                v-on:click.native="openEmojiSelector(i)"
        ></single-emoji-code>
        <div class="emoji-code-picker-container">
            <div class="emoji-code-picker">
                <div class="emoji-code-picker-header">
                    <div
                            :class="'emoji-code-picker-header-triangle-' + activeEmojiIndex"
                            class="emoji-code-picker-header-triangle"
                    >
                    </div>
                </div>
                <div class="emoji-code-picker-emojis">
                    <div
                            :class="codeParts[activeEmojiIndex] === n ? 'emoji-code-active' : ''"
                            class="emoji-code-picker-emoji"
                            v-for="(n, index) in 9"
                            v-on:click="selectEmojiCode(n)"

                    >
                        <img :alt="emojiNames[index]"
                             :aria-label="emojiPronounciation[index]"
                             :src="emojis[index]"
                             :title="emojiNames[index]">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SingleEmojiCode from './single-emoji-code'
    import emojis from './emojis.js'
    import {getEmojiName, getEmojiPronounciation} from './emoji-names.js'

    export default {
        name: 'emoji-code-picker',
        components: {
            SingleEmojiCode
        },
        props: {
            type: {
                type: String,
                required: false,
                default: 'default'
            },
            value: {
                type: String,
                required: false
            },
            activeEmojiIndex: {
                type: Number,
                default: 0
            }
        },
        data() {
            // Split into separate parts
            let codeParts = this.value ? this.value.split(/(?=.)/g) : [];

            // Cast all values to numbers
            codeParts = codeParts.map(Number)

            let emojiNames = [];
            let emojiPronounciation = [];

            for (let i = 0; i < 9; i++) {
                emojiNames.push(getEmojiName(i));
                emojiPronounciation.push(getEmojiPronounciation(i));
            }

            return {
                emojiNames: emojiNames,
                emojis: emojis,
                emojiPronounciation: emojiPronounciation,
                codeParts: codeParts
            }
        },
        watch: {
            value(newValue) {
                // Split into separate parts
                let codeParts = newValue ? newValue.split(/(?=.)/g) : [];

                // Cast all values to numbers
                this.codeParts = codeParts.map(Number)
            }
        },
        methods: {
            openEmojiSelector(index) {
                this.$emit('activeEmojiIndexChange', index)
            },
            selectEmojiCode(emojiCode) {
                let emojiCodeEmptyCountPre = this.codeParts.filter(code => code === 0).length

                this.$set(this.codeParts, this.activeEmojiIndex, emojiCode)

                this.$emit('input', this.codeParts.join(''))

                // Iterate through each codePart and count how many "0"'s are found and check if the total count is 0
                let emojiCodeEmptyCountPost = this.codeParts.filter(code => code === 0).length

                if (emojiCodeEmptyCountPre !== emojiCodeEmptyCountPost) {
                    this.$emit('fillOutStatusChanged', emojiCodeEmptyCountPost === 0)
                }

                if (this.activeEmojiIndex < 4) {
                    // If the next one is empty
                    let nextEmojiIndex = this.activeEmojiIndex + 1

                    if (this.codeParts[nextEmojiIndex] === 0) {
                        this.$emit('activeEmojiIndexChange', nextEmojiIndex)
                    }
                }
            }
        }
    }
</script>
<style lang="less" scoped>
    @import "~@less/mixins/less-triangle.less";

    .emoji-code-container {
        width: 100%;
        text-align: center;

        .emoji-code {
            cursor: pointer;
            transition: all 0.2s ease-in-out;

            &:hover, &.emoji-code-active {
                transform: scale(1.1);
            }
        }
    }

    .emoji-code-picker-container {
        width: 320px;
        margin: 30px auto 0px auto;
    }

    .emoji-code-picker {
        width: 100%;

        .emoji-code-picker-header {
            position: relative;
            top: -15px;

            .emoji-code-picker-header-triangle {
                .triangle(up, 15px, #ffffff);
                position: absolute;
                transition: all 0.2s ease-in-out;

                &.emoji-code-picker-header-triangle-0 {
                    left: 20px;
                }

                &.emoji-code-picker-header-triangle-1 {
                    left: 105px;
                }

                &.emoji-code-picker-header-triangle-2 {
                    left: 190px;
                }

                &.emoji-code-picker-header-triangle-3 {
                    left: 275px;
                }
            }
        }

        .emoji-code-picker-emojis {
            background: white;
            border-radius: 10px;
            padding: 10px 0;

            .emoji-code-picker-emoji {
                width: 65px;
                height: 65px;
                display: inline-block;
                text-align: center;
                background: white;
                margin: 10px;
                padding: 10px;
                border-radius: 5px;
                transition: all 0.2s ease-in-out;
                cursor: pointer;
                border: 1px solid transparent;

                &:hover, &.emoji-code-active {
                    border: 1px solid #8800ff !important;
                }

                img {
                    max-width: 100%;
                    max-height: 100%;
                }
            }
        }
    }
</style>